import React, { useEffect } from "react";
import { View } from "react-native";
import { getShortUrlData } from "../../../services/authAPI";
import { getLoginData } from "../../../utility/AppStoreData";
import * as Linking from "expo-linking";
import { encode } from "js-base64";
import RedirectLoader from "../../../Components/RedirectLoader";

export default function ShortUrlRedirectScreen({ route, navigation }) {
  useEffect(() => {
    handleRedirect();
  }, []);

  const handleRedirect = async () => {
    try {
      // Extract parameters from route
      const params = route.params || {};

      // Get the full URL string from params
      // Deep linking passes the full path after /e/ as the url param
      const urlParam = params.url || "";

      // ref might come as a separate query parameter in route.params
      let ref = params.ref || null;

      console.log("ShortUrlRedirectScreen - URL param:", urlParam);
      console.log("ShortUrlRedirectScreen - All params:", params);

      // Parse shortCode and ref from the URL
      let shortCode = null;

      // URL format: new-event-is-the-king-37052318 (without /e/)
      // or could be full URL if coming from direct browser access
      let slugAndCode = urlParam;

      // If it's a full URL, extract the path
      if (urlParam.includes("http")) {
        try {
          const url = new URL(urlParam);
          slugAndCode = url.pathname.replace("/e/", "");
          if (!ref) {
            ref = url.searchParams.get("ref");
          }
        } catch (e) {
          console.error("Error parsing full URL:", e);
        }
      } else {
        // Parse ref from query string if present in urlParam
        if (urlParam.includes("?ref=")) {
          const parts = urlParam.split("?ref=");
          slugAndCode = parts[0];
          if (!ref) {
            ref = parts[1];
          }
        }
      }

      // Extract shortCode from slug-shortCode format
      // Pattern: event-name-37052318
      const lastDashIndex = slugAndCode.lastIndexOf("-");
      if (lastDashIndex !== -1) {
        shortCode = slugAndCode.substring(lastDashIndex + 1);
      }

      console.log("Extracted shortCode:", shortCode);
      console.log("Extracted ref:", ref);

      if (!shortCode) {
        console.error("No shortCode found in URL");
        // Redirect to home
        navigation.replace("DrawerRoute", { screen: "HomeTabStack" });
        return;
      }

      // Call API to get redirect data with BOTH shortCode and ref
      console.log(`Calling API: getShortUrlData(shortCode="${shortCode}", ref="${ref}")`);
      const response = await getShortUrlData(shortCode, ref);
      console.log("API was called with shortCode AND ref parameters");

      console.log("API Response:", response);

      if (response && response.shareableUrl && response.shareableUrl.fullUrl) {
        let redirectUrl = response.shareableUrl.fullUrl;

        // Check if user is logged in
        const loginData = await getLoginData();
        const isLoggedIn = loginData !== null;

        console.log("User login status:", isLoggedIn ? "Logged in" : "Not logged in");

        // Only append invite parameter if user is NOT logged in
        if (!isLoggedIn && response.referralTracking) {
          const inviteParams = encode(
            JSON.stringify({
              referralCode: response.referralTracking.referralCode,
              directReferrerId: response.referralTracking.directReferrerId,
            })
          );

          // Append invite parameter to the URL
          const separator = redirectUrl.includes("?") ? "&" : "?";
          redirectUrl = `${redirectUrl}${separator}invite=${inviteParams}`;

          console.log("Appended referral data to URL (user not logged in)");
        } else if (isLoggedIn) {
          console.log("User is logged in - skipping invite parameter");
        }

        console.log("Redirecting to:", redirectUrl);

        // Redirect to the full URL
        if (typeof window !== "undefined") {
          window.location.href = redirectUrl;
        } else {
          // Mobile redirect using Linking
          await Linking.openURL(redirectUrl);
        }
      } else {
        console.error("No fullUrl found in response");
        // Redirect to home
        navigation.replace("DrawerRoute", { screen: "HomeTabStack" });
      }
    } catch (error) {
      console.error("Error in ShortUrlRedirectScreen:", error);
      // Redirect to home on error
      navigation.replace("DrawerRoute", { screen: "HomeTabStack" });
    }
  };

  return <RedirectLoader />;
}
